import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { FilterOptionResponse } from '../types'

const fetchFilterOptionEClaimSarabanStatus = async () => {
  const response = await httpClientPrivate.get<FilterOptionResponse[]>(
    `${config.restUrl}/v1/backoffice/e-claim/filter-option/saraban/e-claim-status`,
  )

  return response.data
}

const useFilterOptionEClaimSarabanStatus = () => {
  const queryKey = ['useFilterOptionEClaimSarabanStatus']
  const queryFn = async () => fetchFilterOptionEClaimSarabanStatus()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterOptionEClaimSarabanStatus, useFilterOptionEClaimSarabanStatus }
